import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import FleetTrackingQuotesWrapper from "@components/layouts/fleetTrackingQuotesWrapper";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <FleetTrackingQuotesWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#119188" />
                </div>
                <FormSection iconsFillColor="#119188" />
            </div>
        </FleetTrackingQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
